import { render, staticRenderFns } from "./k-catalog-tree.vue?vue&type=template&id=347f9c39&scoped=true&"
import script from "./k-catalog-tree.vue?vue&type=script&lang=ts&"
export * from "./k-catalog-tree.vue?vue&type=script&lang=ts&"
import style0 from "./k-catalog-tree.vue?vue&type=style&index=0&id=347f9c39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347f9c39",
  null
  
)

export default component.exports